import { render } from "./StaticValue.vue?vue&type=template&id=2e988644"
import script from "./StaticValue.vue?vue&type=script&lang=js"
export * from "./StaticValue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__